import { SessionServerSelectors } from '~selectors/SessionInfoSelectors';

import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { EntityActionNames, IEntityAction } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { runFlowTaskChangePriority } from '../actions/RunFlowTaskMenuActions';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';

export const RunFlowTaskChangePriorityAction: IEntityAction<RunFlowTaskInfo, {}> = {
  name: EntityActionNames.TasksPriority,
  translateName: Messages.tasksSetPriority_action,
  isVisible: (targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: RunFlowTaskInfo[], state: AppState) => {
    const ignoreExtractTaskPriority: boolean =  SessionServerSelectors.ignoreExtractTaskPriority(state);
    return !ignoreExtractTaskPriority && targetItems.length > 0;
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => runFlowTaskChangePriority(targetItems)
};
